import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { IFlatCorporateEvent } from "../../../../../interfaces/corporateEvent";
import RightArrow from "../../../../../assets/svg-fc/RightArrow";
import { fDate } from "../../../../../utils/formatTime";
import {
	formatBudget,
	formatEventDays,
	formatPaymentDays,
} from "../../../../../utils/B2B/corporateEventsUtils";
import { ROUTE_QUERY_CONSTANTS } from "../../../../../routes";
import "./corporateEventCard.scss";

export interface ICorporateEventCardProps {
	type: ROUTE_QUERY_CONSTANTS;
	corporateEvent: IFlatCorporateEvent;
	onClick?: () => void;
}

const CorporateEventCard: FC<ICorporateEventCardProps> = ({ type, corporateEvent, onClick }) => {
	const isApprovedOrCompleted =
		type === ROUTE_QUERY_CONSTANTS.CorporateApprovedEvents ||
		type === ROUTE_QUERY_CONSTANTS.CorporateCompletedEvents;

	const isDeclined = type === ROUTE_QUERY_CONSTANTS.CorporateDeclinedEvents;

	const corporateEventInfo = [
		{
			label: "Event Start Date",
			value: fDate(corporateEvent.startDate as string),
		},
		{
			label: "No. of Days",
			value: formatEventDays(corporateEvent?.numberOfDays as number),
		},
		{
			label: "Budget",
			value: formatBudget(corporateEvent.budget as number),
		},
		{
			label: "Deadline to Quote",
			value: fDate(corporateEvent.externalDeadline as string),
		},
		{
			label: "Payment terms",
			value: formatPaymentDays(corporateEvent?.paymentDays as number),
		},
		...(isApprovedOrCompleted
			? [
					{
						label: "PO number",
						value: corporateEvent.poNumber,
					},
				]
			: isDeclined
				? [
						{
							label: "Declined By",
							value: corporateEvent.declinedBy,
						},
					]
				: []),
	];

	return (
		<Box className="corporateEventCard" onClick={onClick}>
			{/* Header Section */}
			<Box className="corporateEventCardHeader">
				<Box className="corporateEventCardHeaderLeft">
					<Box className="corporateEventCardHeaderTitleContainer">
						<Typography className="corporateEventCardHeaderTitle">{corporateEvent.name}</Typography>
						<Typography className="corporateEventCardHeaderSubtitle">{corporateEvent.eventType}</Typography>
					</Box>
				</Box>
				<RightArrow />
			</Box>
			{/* Info Box */}
			<Box className="corporateEventCardInfoBox">
				{corporateEventInfo.map((info) => (
					<Box key={info.label} className="corporateEventCardInfoItem">
						<Typography className="corporateEventCardInfoItemLabel">{info.label}</Typography>
						<Typography className="corporateEventCardInfoItemValue">{info.value}</Typography>
					</Box>
				))}
			</Box>

			{/* Footer */}
			<Box className="corporateEventCardFooter">
				<Typography className="corporateEventCardFooterLeftLabel">Created by:</Typography>
				<Typography className="corporateEventCardFooterLeftValue">YouCater Corporate Requests</Typography>
			</Box>
		</Box>
	);
};

export default CorporateEventCard;
